import GrantList from '../packages/GrantList.jsx';
import ClipboardText from '../icons/ClipboardText.jsx';
import SectionHeading from '../SectionHeading.jsx';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import DotDotDotMenu from '../DotDotDotMenu';
import useDelete from '../../lib/useDelete.jsx';
import * as Toast from '../../lib/Toast.js';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { formatDate } from '~/lib/DateTime';
import { forwardRef } from 'react';

const GrantRow = ({ grant, refetch, search, onClick, statusBadge }) => {
    const { saveDelete: saveRemove, isDeleting: isRemoving } = useDelete(
        `/packages/grant/${grant.id}/remove/${search?.eventId}`,
        {
            prompt: 'Are you sure you want to remove this package from this event?',
        },
    );

    function doRemove() {
        saveRemove({}).then(() => {
            // Trigger refetch on GrantList
            Toast.success(
                'Successfully removed package from being used by this event',
            );
            refetch();
        });
    }

    return (
        <div className="flex items-center justify-between">
            <div className="flex-1" onClick={onClick}>
                {grant.package?.name || 'Unknown package'}
                {!!grant?.next_renewal_at && (
                    <div className="text-sm text-gray-500">
                        Renews {formatDate(grant?.next_renewal_at)}
                    </div>
                )}
            </div>
            <div>
                {!search?.eventId && statusBadge}
                {!!search?.eventId && (
                    <DotDotDotMenu
                        btnClassName=""
                        options={[
                            {
                                name: 'View',
                                icon: <CalendarIcon />,
                                onClick: onClick,
                            },
                            {
                                name: isRemoving ? 'Removing...' : 'Remove',
                                isDelete: true,
                                onClick: doRemove,
                            },
                        ]}
                    />
                )}
            </div>
        </div>
    );
};

const ClientPackageGrants = forwardRef(
    ({ search, onEditPackages, className }, ref) => {
        return (
            <>
                <GrantList
                    ref={ref}
                    search={search}
                    hideWhenEmpty={true}
                    manualOnClick={true}
                    rowContent={props => (
                        <GrantRow search={search} {...props} />
                    )}
                    headerContent={({ grants }) => {
                        return (
                            <SectionHeading
                                icon={<ClipboardText />}
                                name="Packages & Subscriptions"
                                className={`mb-2 mt-4 ${className}`}
                            />
                        );
                    }}
                    footerContent={() => (
                        <>
                            {!!onEditPackages && (
                                <button
                                    type="button"
                                    className="btn-light-pill mt-2"
                                    onClick={onEditPackages}
                                >
                                    Edit Packages
                                </button>
                            )}
                        </>
                    )}
                />
            </>
        );
    },
);

export default ClientPackageGrants;
